import React from 'react';
import { LogIn, ShieldCheck, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { AAWTA } from '@/lib/aawta';

const AdminLogin = () => {
  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/admin/callback';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-aawta-navy text-white flex items-center justify-center px-6 py-16">
      <div className="absolute inset-0 bg-grid-navy opacity-20 pointer-events-none" />
      <div className="relative w-full max-w-md">
        <Link
          to="/"
          data-testid="admin-login-back"
          className="inline-flex items-center gap-2 text-white/70 hover:text-white text-sm mb-6"
        >
          <ArrowLeft className="h-4 w-4" /> Back to site
        </Link>

        <div className="rounded-3xl bg-white text-aawta-navy p-8 shadow-[0_30px_80px_rgba(0,0,0,0.35)]">
          <div className="flex items-center gap-3">
            <img src={AAWTA.logoUrl} alt="AAWTA" className="h-12 w-12 rounded-full object-cover ring-2 ring-aawta-border" />
            <div>
              <div className="font-display font-bold text-lg">AAWTA Admin</div>
              <div className="text-[11px] tracking-[0.18em] uppercase text-aawta-muted font-medium">
                Workforce Collaborative
              </div>
            </div>
          </div>

          <h1 className="mt-8 font-display text-3xl font-bold tracking-tight">Sign in to continue</h1>
          <p className="mt-3 text-aawta-muted text-[15px] leading-relaxed">
            Access is limited to allow-listed AAWTA team accounts. Sign in with the Google
            account associated with your AAWTA email.
          </p>

          <Button
            onClick={handleGoogle}
            data-testid="admin-login-google"
            className="mt-8 w-full rounded-full bg-aawta-magenta hover:bg-aawta-magenta-hover text-white h-12 font-medium text-[15px] shadow-aawta-magenta"
          >
            <LogIn className="mr-2 h-4 w-4" />
            Sign in with Google
          </Button>

          <div className="mt-6 flex items-start gap-2 text-[13px] text-aawta-muted">
            <ShieldCheck className="h-4 w-4 mt-0.5 text-aawta-magenta shrink-0" />
            <span>
              Secure sign-in powered by Google. We never see or store your password.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
